import { BasicInput, InfoIcon, palette, Tooltip } from '@dev/ee-components';
import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { useCampaignScreensPathsChecker } from '@/components/CampaignCreator/hooks/useCampaignScreensPathsChecker';
import { useGetCampaignInfo } from '@/components/CampaignCreator/hooks/useGetCampaignInfo';
import { getCampainCreatorStore, ModifyCampaignMap } from '@/store/campaignCreator/actions';
import { useDispatch, useSelector } from 'react-redux';

const IconWrapper = styled.span`
    margin-top: 5px;

    svg {
        fill: ${palette.gray[4]};
    }
`;

export const CampaignPreviewText = (): JSX.Element => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { isDetailsScreen } = useCampaignScreensPathsChecker();
    const { activeTemplateIndex } = useSelector(getCampainCreatorStore);
    const { previewText } = useGetCampaignInfo();

    const changePreviewTextHandle = (ev: React.ChangeEvent<HTMLInputElement>): void => {
        const modifyMap = new Map<string, any>();
        modifyMap.set(`CampaignTemplates[${activeTemplateIndex}].Body.PreHeader`, ev?.currentTarget?.value);
        dispatch(ModifyCampaignMap(modifyMap));
    };

    const inputPreviewTextId = `input-preview-text-${activeTemplateIndex}`;

    return (
        <Grid item xs={12} justifyContent="space-between" style={{ marginTop: 24 }}>
            <BasicInput
                id={inputPreviewTextId}
                label={t('previewtext')}
                value={previewText}
                onChange={changePreviewTextHandle}
                readOnly={isDetailsScreen}
                labelIcon={
                    !isDetailsScreen && (
                        <Tooltip
                            color={palette.basic.paper}
                            placement="top"
                            title={t('previewtexttooltiptext')}
                            id="tooltip-preview-text"
                            backgroundColor={palette.gray[6]}
                        >
                            <IconWrapper>
                                <InfoIcon />
                            </IconWrapper>
                        </Tooltip>
                    )
                }
                style={{ marginBottom: 60, marginRight: isDetailsScreen ? 0 : 60 }}
            />
        </Grid>
    );
};
